// src/components/ToggleSwitch.js
import React from 'react';

const ToggleSwitch = ({ label, enabled, setEnabled }) => {
    return (
        <div className="flex items-center justify-between">
            <span className="font-medium text-slate-700">{label}</span>
            <button
                onClick={() => setEnabled(!enabled)}
                className={`relative inline-flex items-center h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                    enabled ? 'bg-blue-600' : 'bg-slate-200'
                }`}
            >
                <span
                    aria-hidden="true"
                    className={`inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                        enabled ? 'translate-x-5' : 'translate-x-0'
                    }`}
                />
            </button>
        </div>
    );
};

export default ToggleSwitch;